<div class="photo-grid-label">
  <label>
    <span i18n="@@sre.images.label">Images</span>
    <span *ngIf="required" class="required-star">*</span>
  </label>
  <span class="photo-count" dir="ltr">{{ photos.length }}/{{ maxPhotos }}</span>
</div>

<div class="photo-grid">
  <div class="photo-cell" *ngFor="let photo of photos; let i = index">
    <div class="photo-tile">
      <img [src]="photo.url" alt="" />
      <button
        *ngIf="editable"
        type="button"
        class="remove-photo"
        (click)="remove(i)"
        i18n-aria-label="@@sre.images.remove"
        aria-label="Remove image">
        <i class="ri-close-line"></i>
      </button>
      <button
        *ngIf="editable"
        type="button"
        class="edit-caption"
        (click)="editCaption(i)"
        i18n-aria-label="@@sre.caption.edit"
        aria-label="Edit caption">
        <i class="ri-pencil-fill"></i>
      </button>
    </div>
    <div class="photo-caption" [class.no-caption]="!photo.caption">
      <ng-container *ngIf="photo.caption; else noCaption">{{ photo.caption }}</ng-container>
      <ng-template #noCaption><span i18n="@@sre.caption.none">No caption</span></ng-template>
    </div>
  </div>

  <label *ngIf="canAdd" class="photo-cell">
    <div class="photo-tile add-tile" [class.error]="showError">
      <input type="file" accept="image/*" (change)="onFileChange($event)" class="file-input" />
      <i class="ri-camera-fill"></i>
      <span i18n="@@sre.images.add">Add Image</span>
    </div>
  </label>
</div>

<div *ngIf="showError" class="photo-error" i18n="@@sre.images.required">Add at least one image.</div>

<p-dialog
  [(visible)]="captionDialogVisible"
  [modal]="true"
  [closable]="false"
  [baseZIndex]="10000"
  [style]="{ width: '32rem' }"
  header="Image caption"
  i18n-header="@@sre.caption.title">
  <textarea
    class="p-inputtextarea p-component caption-input"
    rows="5"
    [(ngModel)]="captionDraft"
    [attr.maxlength]="maxCaptionLength"
    placeholder="Add a caption (optional)"
    i18n-placeholder="@@sre.caption.placeholder"></textarea>
  <div class="caption-counter">{{ captionDraft.length }}/{{ maxCaptionLength }}</div>

  <div class="caption-actions">
    <button
      pButton
      type="button"
      class="p-button-text"
      [label]="isNewPhoto ? skipLabel : cancelLabel"
      (click)="skipOrCancelCaption()"></button>
    <button pButton type="button" class="p-button-primary" [label]="saveLabel" (click)="saveCaption()"></button>
  </div>
</p-dialog>
